/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import {
  call,
  delay,
  fork,
  put,
  select,
  take,
  takeLatest,
} from 'redux-saga/effects';

import SDK from 'utils/sdk';
import { SubmissionError } from 'redux-form';
import { messageError } from 'views/ui/toast-message';
import { getSelectedEquipment, getSelectedLocation } from './selector';
import {
  getLocationEquipments,
  refreshAllLocationEquipments,
  refreshLocationEquipments,
  restartAllLocationEquipments,
  restartLocationEquipments,
  startPolling,
  stopPolling,
} from './actions';

export function* listLocationEquipmentsSaga() {
  try {
    const selectedLocation = yield select(getSelectedLocation);
    yield put(getLocationEquipments.request());
    const client = yield call([SDK, 'getClient']);
    const { data } = yield call([client, 'getLocationEquipments'], {
      locationId: selectedLocation._id,
    });
    yield put(getLocationEquipments.success(data));
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(
      getLocationEquipments.failure(new SubmissionError({ _error: data }))
    );
    messageError(data);
  } finally {
    yield put(getLocationEquipments.fulfill());
  }
}
export function* refreshLocationEquipmentsSaga() {
  try {
    yield put(refreshLocationEquipments.request());
    const selectedEquipment = yield select(getSelectedEquipment);
    const client = yield call([SDK, 'getClient']);
    yield call([client, 'refreshLocationEquipment'], {
      id: selectedEquipment,
    });
    yield put(refreshLocationEquipments.success());
    yield put(getLocationEquipments());
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(
      refreshLocationEquipments.failure(new SubmissionError({ _error: data }))
    );
    messageError(data);
  } finally {
    yield put(refreshLocationEquipments.fulfill());
  }
}

export function* refreshAllLocationEquipmentsSaga() {
  try {
    yield put(refreshAllLocationEquipments.request());
    const selectedLocation = yield select(getSelectedLocation);
    const client = yield call([SDK, 'getClient']);
    yield call([client, 'refreshAllLocationEquipments'], {
      locationId: selectedLocation._id,
    });
    yield put(refreshAllLocationEquipments.success());
    yield put(getLocationEquipments());
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(
      refreshAllLocationEquipments.failure(
        new SubmissionError({ _error: data })
      )
    );
    messageError(data);
  } finally {
    yield put(refreshAllLocationEquipments.fulfill());
  }
}

export function* restartLocationEquipmentsSaga() {
  try {
    yield put(restartLocationEquipments.request());
    const selectedEquipment = yield select(getSelectedEquipment);
    const client = yield call([SDK, 'getClient']);
    yield call([client, 'restartLocationEquipment'], {
      id: selectedEquipment,
    });
    yield put(restartLocationEquipments.success());
    yield put(getLocationEquipments());
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(
      restartLocationEquipments.failure(new SubmissionError({ _error: data }))
    );
    messageError(data);
  } finally {
    yield put(restartLocationEquipments.fulfill());
  }
}

export function* restartAllLocationEquipmentsSaga() {
  try {
    yield put(restartAllLocationEquipments.request());
    const selectedLocation = yield select(getSelectedLocation);
    const client = yield call([SDK, 'getClient']);
    yield call([client, 'restartAllLocationEquipments'], {
      locationId: selectedLocation._id,
    });
    yield put(restartAllLocationEquipments.success());
    yield put(getLocationEquipments());
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(
      restartAllLocationEquipments.failure(
        new SubmissionError({ _error: data })
      )
    );
    messageError(data);
  } finally {
    yield put(restartAllLocationEquipments.fulfill());
  }
}

function* watchStartPolling() {
  let activePolling = true;
  yield fork(function* _close() {
    yield take(stopPolling.TRIGGER);
    activePolling = false;
  });
  while (activePolling) {
    yield put(getLocationEquipments());
    yield delay(2 * 60 * 1000);
  }
}

export default function* stationEquipmentsWatch() {
  yield takeLatest(getLocationEquipments.TRIGGER, listLocationEquipmentsSaga);
  yield takeLatest(
    refreshLocationEquipments.TRIGGER,
    refreshLocationEquipmentsSaga
  );
  yield takeLatest(
    refreshAllLocationEquipments.TRIGGER,
    refreshAllLocationEquipmentsSaga
  );
  yield takeLatest(
    restartLocationEquipments.TRIGGER,
    restartLocationEquipmentsSaga
  );
  yield takeLatest(
    restartAllLocationEquipments.TRIGGER,
    restartAllLocationEquipmentsSaga
  );
  yield takeLatest(startPolling.TRIGGER, watchStartPolling);
}
